import { useEffect, useMemo, useState } from 'react';

import { diffInSeconds, formatDurationClockTime } from '../../helper/time';
import { type SimulationState, simulationButtonActions } from './utils';

interface SimulationItemProps {
    vin: string;
    selected: string | undefined;
    isLoading: boolean;
    onClick(vin: string): void;
    selectSimulation(i: string): void;
    simulationState: SimulationState;
    startedAt?: string;
}

const SimulationItem = ({
    vin,
    selected,
    isLoading,
    selectSimulation,
    onClick,
    simulationState,
    startedAt,
}: SimulationItemProps) => {
    const [timeDifference, setTimeDifference] = useState('');
    const isSelected = selected === vin;
    const icon = simulationButtonActions.get(simulationState)?.icon;
    // Memoize the 'date' variable so it doesn't change unnecessarily on every render
    const date = useMemo(() => (startedAt ? new Date(startedAt) : null), [startedAt]);
    useEffect(() => {
        if (date != null) {
            const intervalId = setInterval(() => {
                const differenceInSeconds = diffInSeconds(new Date(), date);
                const formattedTime = formatDurationClockTime(differenceInSeconds);
                setTimeDifference(`${formattedTime}`);
            }, 1000);
            return () => clearInterval(intervalId);
        }
    }, [date]);
    return (
        <div
            className={`display-grid width-100pct grid-cols-10 align-items-center justify-content-between p-10 ${isSelected ? 'bg-primary' : 'bg-white'}`}
        >
            <div className='col-span-6'>
                <div
                    className='display-flex width-100pct cursor-pointer align-items-center justify-content-between'
                    onClick={() => selectSimulation(vin)}
                >
                    <p>{vin}</p>
                </div>
            </div>
            <div className='col-span-3'>{startedAt != null && <p className='text-success'>{timeDifference}</p>}</div>
            <div className='col-span-1 display-flex justify-content-end'>
                <button
                    data-testid='start-simulation-button'
                    disabled={isLoading}
                    onClick={() => onClick(vin)}
                    className={`display-flex cursor-pointer align-items-center justify-content-center rounded-xl border p-5 ${isSelected ? 'border-white' : 'border-gray-dark'}`}
                >
                    <span className={`${icon} text-16`} />
                </button>
            </div>
        </div>
    );
};

export default SimulationItem;
